/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/** Typed runtime config from Vite env (single import.meta.env access point). */
const tenantId = import.meta.env.VITE_AAD_TENANT_ID ?? '';
const explicitAuthority = import.meta.env.VITE_AAD_AUTHORITY ?? '';

export const config = {
  appName: import.meta.env.VITE_APP_NAME ?? 'eDiagnostics',
  // Inlined from backend/pom.xml <version> at build time (see vite.config.ts).
  appVersion: __APP_VERSION__,
  // CI run number inlined at build time; "local" for developer builds (see vite.config.ts).
  buildNumber: __BUILD_NUMBER__,
  api: {
    // Empty base -> full paths proxied to the backend in dev (see vite.config.ts).
    baseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  },
  auth: {
    clientId: import.meta.env.VITE_AAD_CLIENT_ID ?? '',
    tenantId,
    authority:
      explicitAuthority || (tenantId ? `https://login.microsoftonline.com/${tenantId}` : ''),
    // `||` (not `??`) so empty env vars fall back to origin for MSAL.
    redirectUri: import.meta.env.VITE_AAD_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri:
      import.meta.env.VITE_AAD_POST_LOGOUT_REDIRECT_URI || window.location.origin,
    // Scopes requested for the app's own backend API (space separated in env).
    apiScopes: (import.meta.env.VITE_AAD_API_SCOPES ?? '')
      .split(' ')
      .map((s) => s.trim())
      .filter(Boolean),
  },
} as const;

/** True when MSAL has been configured with an authority + client id. */
export const isAuthConfigured = (): boolean =>
  Boolean(config.auth.authority && config.auth.clientId);
